import { useEffect } from 'react';

/**
 * @function useRebrandHeadlineFont
 * @description Hook. Adds a data attribute to root element (HTML) if feature flag is true
 * @param {string} [dataAttribute] html data atrribute
 * @return {boolean | undefined} Value of the feature flag passed in
 */
const useAddFeatureFlagToRoot = (
  dataAttribute: string,
  featureFlag: boolean | undefined
): boolean | undefined => {
  useEffect(() => {
    if (dataAttribute && featureFlag) {
      const rootEl = document.querySelector('html');
      if (rootEl) {
        rootEl.setAttribute(dataAttribute, 'true');
      }
    }
  }, [dataAttribute, featureFlag]);

  return featureFlag;
};

export default useAddFeatureFlagToRoot;
